<style lang="scss" scoped>
  .el-footer {
    line-height: 60px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .footerContent {
    max-width: 1200px;
    margin: 0 auto;
    font-size: 13px;
  }
</style>
<template>
  <el-footer>
    <div class="footerContent">{{typeHash == '#normal'?'编玩边学教育科技有限公司':'主办方：蓝桥杯组委会青少组'}}</div>
  </el-footer>
</template>
<script>
  export default {
    name: 'BaseFooter',
    data() {
      return {
        typeHash: sessionStorage.getItem('hash') || this.$route.hash
      };
    },
    methods: {},
    components: {},
    created() {
    },
    mounted() {
    },
    props: {},
    watch: {},
  };
</script>
